<template>
  <div class="product" :class="cls">
    <button @click="$emit('click-product')" class="btn product-btn">
      <div class="product-picture">
        <img
          class="product-img"
          v-if="product.img_link"
          :src="imgLink"
          :alt="product[`name_${lang}`]"
        />
        <div class="product-img" v-else></div>
      </div>
      <div class="product-info">
        <h1 class="product-name">
          {{ product[`name_${lang}`] }}
        </h1>
        <div class="product-price-container">
          <div class="product-list-price">&euro; {{ listPrice }}</div>
          <div class="product-price">&euro; {{ price }}</div>
        </div>
      </div>
    </button>
    <a @click="$emit('open-link')" class="product-a">
      <div class="product-picture">
        <img
          class="product-img"
          v-if="product.img_link"
          :src="imgLink"
          :alt="product[`name_${lang}`]"
        />
        <div class="product-img" v-else></div>
      </div>
      <div class="product-info">
        <h1 class="product-name">
          {{ product[`name_${lang}`] }}
        </h1>
        <div class="product-price-container">
          <div class="product-list-price">&euro; {{ listPrice }}</div>
          <div class="product-price">&euro; {{ price }}</div>
        </div>
      </div>
    </a>
    <div class="product-buttons">
      <CarouselButton
        @click="$emit('load-more')"
        icon="plus"
        iconColor="#005AA6"
        textColor="#005AA6"
        bgColor="white"
        >{{ removeEmoji($root.__('more like this')) }}</CarouselButton
      >
      <CarouselButton
        v-if="$root.cart"
        @click="addToCartAndRedirect"
        icon="add-to-cart"
        iconColor="white"
        textColor="white"
        bgColor="#2DC76D"
        >{{ removeEmoji($root.__('in cart')) }}</CarouselButton
      >
    </div>
  </div>
</template>

<script>
import CarouselButton from './CarouselButton.vue'
import ProductPage from './ProductPage.vue'

import { chat } from '../chat.js'
import { envReplace, refParam, removeEmoji } from '../util.js'

export default {
  props: {
    product: null
  },
  components: {
    CarouselButton,
    ProductPage
  },
  computed: {
    cls() {
      return {
        testStyle: 1,
        'product--promo': this.listPrice > this.price
      }
    },
    lang() {
      return this.$root.state.lang || 'nl'
    },
    price() {
      return parseFloat(this.product.price)
    },
    listPrice() {
      return parseFloat(this.product.list_price)
    },
    link() {
      return refParam(envReplace(this.product['link_' + this.lang]))
    },
    imgLink() {
      return envReplace(this.product.img_link)
    },
    syst() {
      const { host } = window.location
      return host.indexOf('syst.') > -1 || host.indexOf('test.') > -1
    }
  },
  data() {
    return {
      showProductPage: false
    }
  },
  created() {
    this.$root.track({
      event_type: 'impression',
      action_item: this.product.product,
      page_type: 'dreambuddy',
      list_name: this.product.list_name,
      request_id: `${this.product.request_id}`
    })
  },
  methods: {
    removeEmoji,
    addToCart(v) {
      this.$root.track({
        event_type: 'add_to_cart',
        page_type: 'dreambuddy',
        amount: 1,
        action_item: this.product.product
      })
      return addToCart(typeof v === 'string' ? { product: v } : this.product)
    },
    addToCartAndRedirect(v) {
      this.addToCart(v)
        .then(() => {
          chat.send({ data: { product: this.product }, next: 'cart' })
        })
        .catch(e => {
          chat.send({
            text: $root.__('failed to add to cart'),
            next: 'cartError'
          })
        })
    }
  }
}

function addToCart(product) {
  return new Promise((resolve, reject) => {
    window.addEventListener(
      'message',
      function response(evt) {
        if (evt.data.type === 'ok:addToCart') {
          resolve()
          window.removeEventListener('message', this.onmessage, false)
        }
        if (evt.data.type === 'err:addToCart') {
          reject()
          window.removeEventListener('message', this.onmessage, false)
        }
      },
      false
    )
    window.top.postMessage(
      { type: 'addToCart', productId: product.product, product },
      '*'
    )
  })
}
</script>

<style>
.product {
  position: relative;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  background: white;
  color: black;
}
.product-picture {
  padding-bottom: 1em;
}
.product-img {
  display: block;
  height: 9em;
  width: auto;
  max-width: 100%;
  margin: 0 auto;
  object-fit: contain;
}
.product-btn {
  display: block;
  padding: 1em;
  color: inherit;
  text-decoration: inherit;
  box-shadow: none;
  width: calc(100% - 1em);
  margin: 0 auto;
}
.product-a {
  display: block;
  padding: 1em;
  color: inherit;
  text-decoration: inherit;
}
.product-info {
  height: 6em;
}
.product-name {
  margin: 0;
  font-size: 16px;
  line-height: 1.4em;
  height: 2.8em;
  overflow: hidden;
  color: #005aa6;
  font-weight: 400;
}
.product-list-price {
  display: none;
}
.product-price {
  margin: 0;
  font-size: 19px;
  line-height: 22px;
  color: #696e80;
}
.product-link {
  font-size: 12px;
  line-height: 2em;
  text-decoration: underline;
  color: #08abfc;
}
.product-a:hover .product-link {
  text-decoration: none;
  color: #005ba9;
}
.product-like {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 10px;
}
.product-like-btn {
  display: block;
  border: none;
  border-radius: 1em;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  padding: 0;
  width: 2em;
  height: 2em;
  background: white;
  font-size: 24px;
  outline: none;
  transition: box-shadow 0.3s;
  vertical-align: top;
  -webkit-appearance: none;
  appearance: none;
}
.product-like-btn:active {
  box-shadow: 0px 0px 0 3px rgba(0, 0, 0, 0.3);
}
.product-like svg {
  transition: transform 0.2s;
}
.product-like:hover svg {
  transform: scale(1.25);
}
.product-like:focus {
  outline: none;
}

.product--promo .product-picture::after {
  content: 'Promo';
  position: absolute;
  top: 0.8em;
  left: 0.8em;
  border-radius: 19px;
  padding: 0 1em;
  line-height: 24px;
  background: #a62f2f;
  color: white;
}
.product--promo .product-list-price {
  display: block;
  margin: 0;
  text-decoration: line-through;
  color: #000;
  opacity: 0.4;
  font-size: 16px;
}
.product--promo .product-price {
  color: #a62f2f;
  margin-left: 10px;
  font-size: 19px;
}

.testStyle .product-like {
  bottom: -34px;
  padding-right: 1.5em;
}
.product-price-container {
  display: flex;
  align-items: center;
  margin-top: 12px;
}
@media (max-width: 999px) {
  .product-btn {
    display: none;
  }
}
@media (min-width: 1000px) {
  .product-a {
    display: none;
  }
}
</style>
